import { HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Observable, catchError, finalize, switchMap, take, tap, throwError } from 'rxjs';
import { AuthService } from '@app/core/services';
import { LoadingService } from '@app/shared/services/loading.service';

export const linqHttpInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const loadingService = inject(LoadingService);

  // Wait for the access token to be available before proceeding
  return authService.accessToken$.pipe(
    take(1),
    tap((token) => {}),
    switchMap((token) => {
      let authorization = req.headers.get('Authorization');
      if (!authorization && token) {
        authorization = `Bearer ${token}`;
      }

      const headers = {
        Authorization: authorization ?? '',
        'X-Timezone-Offset': new Date().getTimezoneOffset().toString(),
      };

      const httpReq = req.clone({
        setHeaders: headers,
      });

      // loading service
      loadingService.trySkipNextRequest(req.method, req.url);
      loadingService.show();

      return next(httpReq).pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        }),
        finalize(() => {
          loadingService.hide();
        }),
      );
    }),
  );
};
